import TEMPLATE_URL from 'emun.customer/parser/customer-parser.htm'
import controller from 'emun.customer/parser/customer-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'Customer Bulk Pad...',
    subTitle = 'Enter customer IDs separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onCustomerSelected = NOOP,
    onCustomerDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onCustomerSelected,
                onCustomerDeselected,
                view,
            })
        }
    }).result;